// Module
var code = `<div class="pair-color" style="{{>visibility}}">
    {{#.pairColor}}
    <terceraButtonColorPicker coloringButtonColor="{{.Color1}}" enabled="{{~/enabled}}" BackText="{{.ColorText1}}" colorPickerClicked="{{colorPickerClicked}}" />
    <terceraButtonColorPicker coloringButtonColor="{{.Color2}}" enabled="{{~/enabled}}" BackText="{{.ColorText2}}" colorPickerClicked="{{colorPickerClicked}}" />
    {{/}}
</div>`;
// Exports
export default code;